<template>
  <BjDrawerForm ref="BjDrawerForm" :form="form" :rules="rules" label-width="120px" @handleConfirm="handleConfirm">
    <el-col :span="22">
      <el-form-item :label="$t('goodsBrand.table.name')" prop="brandName">
        <BjInput v-model="form.brandName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>
    <el-col :span="22">
      <BjFormItemCode v-model="form.code" :label="$t('goodsBrand.table.code')" prop="code" />
    </el-col>
    <el-col :span="22">
      <el-form-item :label="$t('goodsBrand.table.Manufacturer')" prop="manufacturer">
        <BjInput v-model="form.manufacturer" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>
    <el-col :span="22">
      <el-form-item :label="$t('table.remarkText')" prop="remark">
        <BjInput v-model="form.remark" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>
    <el-col :span="22">
      <el-form-item :label="$t('goodsBrand.table.LOGO')" prop="logo">
        <BjUpload ref="upload" class="avatar-uploader" auto-upload accept="image/png,image/jpeg,image/gif" :accept-list="['image/jpeg', 'image/png', 'image/gif']" :limit-size="50" :out-size-text="$t('goodsBrand.page.uploadedSize')" @afterUpload="afterUpload">
          <template slot="default">
            <BjKeyImage v-if="form.logo" :url="form.logo" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </template>
          <template slot="tip">
            {{ $t('goodsBrand.page.uploadedTip') }}
          </template>
        </BjUpload>
      </el-form-item>
    </el-col>
  </BjDrawerForm>
</template>
<script>
import { goodsApi } from '@/api';

import BjUpload from '@/components/BjUpload/index';
const getDefaultForm = () => {
  return {
    brandName: null,
    id: null,
    code: null,
    logo: null,
    manufacturer: null,
    remark: null,
    status: 1,
  };
};

export default {
  components: {
    BjUpload,
  },
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        brandName: [{ required: true, message: this.$t('goodsBrand.page.PleaseBrand'), trigger: 'blur' }],
      },
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    afterUpload(res) {
      this.form.logo = res;
    },
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('goodsBrand.page.EditBrand') : this.$t('goodsBrand.page.CreateBrand'));
      this.form = Object.assign(getDefaultForm(), info || {});
    },

    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      }

      if (this.isEdit) {
        this.updateApi(API_DATA);
      } else {
        this.addApi(API_DATA);
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },
    addApi(API_DATA) {
      goodsApi.addBrand(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    updateApi(API_DATA) {
      goodsApi.updateBrand(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
